import React from "react";
import { useNavigate } from "react-router-dom";
import "./Common_Back_Header.css";

const Common_Back_Header = ({ backNavigation = "/" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof backNavigation === "number") {
      navigate(-backNavigation);
    } else {
      navigate(backNavigation);
    }
  };

  return (
    <section className="Common_Back_Header">
      <p className="back_text" onClick={handleBack}>
        ← Back
      </p>
    </section>
  );
};

export default Common_Back_Header;